import { Injectable } from '@angular/core';
import { PayoutFeeConfig } from 'src/app/types/PayoutFeeConfig';
import { AffiliateCommission } from '../../../types/AffiliateCommission';
import { AffiliateVendor } from '../../../types/AffiliateVendor';
import { CoreService } from '../../core.service';
import { IAffiliatesService } from '../IAffiliatesService';
import { mockAffiliateVendors } from './mock-data';

@Injectable({
  providedIn: 'root',
})
export class MockAffiliatesService implements IAffiliatesService {
  constructor(private _coreService: CoreService) {}

  getAffiliateVendors(): Promise<{
    affiliate_code: string;
    affiliate_vendors: AffiliateVendor[];
    is_premium_affiliate_manager: boolean;
  }> {
    return this._coreService.delayResolve({
      affiliate_code: 'ONDC',
      affiliate_vendors: mockAffiliateVendors,
      is_premium_affiliate_manager: false, // Mock as premium for testing
    });
  }

  updatePayoutFeeConfig(
    affiliateVendorId: string,
    payoutFeeConfig: PayoutFeeConfig,
  ): Promise<void> {
    console.log('updatePayoutFeeConfig', affiliateVendorId, payoutFeeConfig);
    return this._coreService.delayResolve(undefined);
  }

  getAffiliateCommissions(): Promise<{
    total_commission_earned_amount: number;
    affiliate_commissions: AffiliateCommission[];
  }> {
    console.log('MockAffiliatesService.getAffiliateCommissions called');

    // Mock data for commissions - Updated with real vendor names and amounts
    const mockCommissions: AffiliateCommission[] = [
      {
        commissionEarnedDate: '2024-08-15',
        payoutReference: 'payout_f0A_1756916807475_iNFwX_000',
        vendor: 'ADANI GREEN ENERGY LIMITED',
        email: 'hello@adanigreenenergy.com',
        grossAmount: 100,
        netAmount: 100,
        settledAmount: 8715.77,
        commissionEarnedAmount: 15.85,
      },
      {
        commissionEarnedDate: '2024-08-10',
        payoutReference: 'payout_f0A_1756456126999_snlBF_001',
        vendor: 'TATA DIGITAL PRIVATE LIMITED',
        email: 'contact@tatadigital.com',
        grossAmount: 50,
        netAmount: 0,
        settledAmount: 4340.45,
        commissionEarnedAmount: 5382.41,
      },
      {
        commissionEarnedDate: '2024-08-05',
        payoutReference: 'payout_f0A_1756916536315_bnnGU_000',
        vendor: 'ADANI GREEN ENERGY LIMITED',
        email: 'hello@adanigreenenergy.com',
        grossAmount: 100,
        netAmount: 100,
        settledAmount: 8715.68,
        commissionEarnedAmount: 15.85,
      },
      {
        commissionEarnedDate: '2025-09-08',
        payoutReference: 'payout_f0A_1756955594889_psTAC_000',
        vendor: 'ADANI GREEN ENERGY LIMITED',
        email: 'hello@adanigreenenergy.com',
        grossAmount: 1500,
        netAmount: 1500,
        settledAmount: 130793.1,
        commissionEarnedAmount: 2.7,
      },
      {
        commissionEarnedDate: '2024-08-25',
        payoutReference: 'payout_f0A_1756886126999_snlBF_004',
        vendor: 'TATA DIGITAL PRIVATE LIMITED',
        email: 'contact@tatadigital.com',
        grossAmount: 50,
        netAmount: 0,
        settledAmount: 4340.45,
        commissionEarnedAmount: 5382.41,
      },
      {
        commissionEarnedDate: '2024-08-27',
        payoutReference: 'payout_f0A_1756886126999_snlBF_005',
        vendor: 'ADANI GREEN ENERGY LIMITED',
        email: 'hello@adanigreenenergy.com',
        grossAmount: 2000,
        netAmount: 1900,
        settledAmount: 165000.0,
        commissionEarnedAmount: 100.0,
      },
      {
        commissionEarnedDate: '2024-08-28',
        payoutReference: 'payout_f0A_1756886126999_snlBF_006',
        vendor: 'TATA DIGITAL PRIVATE LIMITED',
        email: 'contact@tatadigital.com',
        grossAmount: 300,
        netAmount: 285,
        settledAmount: 25000.0,
        commissionEarnedAmount: 15.0,
      },
      {
        commissionEarnedDate: '2025-08-27',
        payoutReference: 'payout_f0A_1756886126999_snlBF_007',
        vendor: 'ADANI GREEN ENERGY LIMITED',
        email: 'hello@adanigreenenergy.com',
        grossAmount: 800,
        netAmount: 760,
        settledAmount: 66000.0,
        commissionEarnedAmount: 40.0,
      },
    ];

    const result = {
      total_commission_earned_amount: 5582.41, // Updated total based on new amounts
      affiliate_commissions: mockCommissions,
    };

    console.log('MockAffiliatesService returning:', result);

    return this._coreService.delayResolve(result);
  }
}
